<template>
  <ticket-line-details
    :ticket-open-bets="ticketOpenBets"
    :ticket-graded-bets="ticketGradedBets"
    :scan-detail-response="scanDetailResponse"
  />
</template>

<script>
import { mapState } from 'vuex';
import TicketLineDetails from './TicketLineDetails';

export default {
  components: { TicketLineDetails },
  computed: {
    ...mapState('clerkWagerStore', ['ticketGradedBets', 'ticketOpenBets', 'scanDetailResponse']),
  },
};
</script>
